import {Select, PlotTypeSelector, RangeDiscrete, Switch} from 'svelte-controls-basic';


export const CLASS_COLORS = ["#7b3294", "#008837"];

// get vector with colors
export function getColors(resobj) {

   if (!resobj.ind) {
      // no reference classes - all is gray
      return new Array(resobj.nrows).fill('#747573');
   }

   const colors = new Array(resobj.nrows);

   let y = 0;
   for (let c of resobj.classNames) {
      const col = CLASS_COLORS[y];
      for (let i of resobj.ind[c]) {
         colors[i] = col;
      }
      y = y + 1;
   }

   return colors;
}

// get the reference class of each object for the CSV exports, empty where there is none.
// takes a DA result, as 'getColors': a PLS result has no 'ind'
export function getClasses(resobj) {

   const classes = new Array(resobj.nrows).fill('');
   if (!resobj.ind) return classes;

   for (let c of resobj.classNames) {
      for (let i of resobj.ind[c]) {
         classes[i] = c;
      }
   }

   return classes;
}


export function getPlotFoMControls(res, classNames) {

   const resIDs = Object.keys(res);
   const options = resIDs.length > 1 ? [...resIDs, 'both'] : resIDs;
   const foms = ['sens', 'spec', 'eff', 'acc'];
   const defaultOption = resIDs.length > 1 ? 'both' : resIDs[0];
   const classes = [...classNames, 'total'];

   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: defaultOption, label: 'Show', props: {options: options}},
      fom: { el: Select, hidden: false, default: 'eff', label: 'FoM', props: {options: foms}},
      className: { el: Select, hidden: false, default: 'total', label: 'Class', props: {options: classes}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}


export function getPlotDiscriminationControls(resIDs, classNames) {
   const showOptions = [...classNames, "both"]
   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Show', props: {options: resIDs}},
      className: { el: Select, hidden: false, default: classNames[0], label: 'Class', props: {options: showOptions}},
      showOutliers: { el: Switch, hidden: false, default: false, label: 'Outliers zone', props: {options: ['hide', 'show']}},
      showLabels: { el: Select, hidden: false, default: 'hide', label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}


export function getPlotROCControls(resIDs) {
   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Show', props: {options: resIDs}},
   };
   return controls;
}

export function getPlotFoMHeatmapControls(resIDs) {

   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Show', props: {options: resIDs}},
      fom: { el: Select, hidden: false, default: 'eff', label: 'FoM', props: {options: ['sens', 'spec', 'eff']}},
   };
   return controls;
}


export function getPlotScoresControls(res) {

   const resIDs = Object.keys(res);
   const resobj = res[resIDs[0]];

   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Show', props: {options: resIDs}},
      comp2: { el: RangeDiscrete, hidden: false, default: resobj.ncomp > 1 ? 2 : 1, label: 'LV (y-axis)', props: {min: 1, max: resobj.ncomp}},
      comp1: { el: RangeDiscrete, hidden: false, default: 1, label: 'LV (x-axis)', props: {min: 1, max: resobj.ncomp}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}

export function getPlotDistanceControls(res) {

   const resIDs = Object.keys(res);
   const resobj = res[resIDs[0]];


   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Show', props: {options: resIDs}},
      distType: { el: Select, hidden: resobj.Yref === null, default: 'h/q', label: 'Distance', props: {options: ['h/q', 'f/z']}},
      transType: { el: Select, hidden: false, default: 'no', label: 'Transform', props: {options: ['no', 'log']}},
      limType: { el: Select, hidden: false, default: 'classic', label: 'Limits', props: {options: ['classic', 'robust']}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}